import React from "react";
import uuid from "react-uuid";

import { useWorkflow } from "../../../../context/WorkflowContext";

import LegalAllowanceActions from "./LegalAllowanceActions";
import ActivitiesManagementActions from "./ActivitiesManagementActions";
import OvertimeActions from "./OvertimeActions";
import TachDocumentActions from "./TachDocumentActions";

const WorkflowActions = ({ workflow }: any) => {
    const { workflowFilter } = useWorkflow();

    const handleLegalAllowanceActions = () =>
        workflowFilter.workflowTypeId.toString() === "2" && (
            <LegalAllowanceActions key={uuid()} workflow={workflow} />
        );

    const handleActivitiesManagementActions = () =>
        workflowFilter.workflowTypeId.toString() === "3" && (
            <ActivitiesManagementActions key={uuid()} workflow={workflow} />
        );

    const handleOvertimeActions = () =>
        workflowFilter.workflowTypeId.toString() === "4" && (
            <OvertimeActions key={uuid()} workflow={workflow} />
        );

    const handleTachDocumentActions = () =>
        workflowFilter.workflowTypeId.toString() === "5" && (
            <TachDocumentActions key={uuid()} workflow={workflow} />
        );

    return (
        <>
            {handleLegalAllowanceActions()}
            {handleActivitiesManagementActions()}
            {handleOvertimeActions()}
            {handleTachDocumentActions()}
        </>
    );
};

export default WorkflowActions;
